"use client"
import useApi from "@/hooks/useApi"
import React, { useState, useEffect } from "react"
import Select, { StylesConfig } from "react-select"

const SearchElementMulti: React.FC<{
  apiUrl: string
  placeholder?: string
  selectButtonText?: string
  onSelect: (elements: { id: any; name: any }[]) => void
}> = ({ apiUrl, placeholder, selectButtonText = "Dalej", onSelect }) => {
  const [query, setQuery] = useState("")
  const [elements, setElements] = useState([])
  const [result, setResult] = useState<{ id: string, name: string}[]>([])
  const [showError, setShowError] = useState(false)
  const queryString = query !== "" ? `&q=${query}` : ""
  const response = useApi(
    `${apiUrl}?size=20${queryString}`
  )

  useEffect(() => {
    if (response.data) {
      const sortedElements = response.data.sort((a: any, b: any) => {
        if (a.name.length === b.name.length) {
          return a.name.localeCompare(b.name)
        }
        return a.name.length - b.name.length
      })
      setElements(sortedElements)
    }
  }, [query, response])

  const customStyles: StylesConfig = {
    menuPortal: (provided: any) => ({
      ...provided,
      zIndex: 9999,
    }),
    control: provided => ({
      ...provided,
      fontSize: "1.5rem",
      minHeight: "2.2rem",
      border: "1px solid #e5e7eb",
      boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
      backgroundColor: "white",
      borderRadius: "1rem",
    }),
    valueContainer: provided => ({
      ...provided,
      padding: "0.4rem 1rem",
    }),
    input: provided => ({
      ...provided,
      fontSize: "1.5rem",
      lineHeight: "1.2",
    }),
    singleValue: provided => ({
      ...provided,
      fontSize: "1.5rem",
      color: "black",
    }),
    placeholder: provided => ({
      ...provided,
      fontSize: "1.5rem",
      color: "#9ca3b7",
    }),
    menu: provided => ({
      ...provided,
      fontSize: "1.5rem",
      borderRadius: "0.8rem",
      marginTop: "0.3rem",
      boxShadow: "0 4px 16px rgba(0, 0, 0, 0.13)",
      backgroundColor: "#001831",
      overflow: "hidden",
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "1.5rem",
      backgroundColor: state.isFocused ? "#00335d" : "#001831",
      color: "white",
      padding: "0.7rem 1.2rem",
      cursor: "pointer",
      transition: "background 0.15s",
    }),
  }

  return (
    <>
      <div className='rounded-2xl relative flex flex-col md:flex-row items-center gap-3 bg-white w-full p-4 shadow-lg'>
        <div className="flex-1 w-full">
          <Select
            name='search'
            isMulti
            instanceId="search"
            options={
              elements
                ? elements.map((el: any) => {
                    return { label: el.name, value: el.id }
                  })
                : []
            }
            className='text-black w-full'
            classNamePrefix='select'
            styles={customStyles}
            menuPosition='fixed'
            placeholder={placeholder ?? "Wyszukaj"}
            noOptionsMessage={() => "Brak opcji"}
            onChange={(e: any) => {
              setResult(e.map((el: {label: string, value: string}) => { return {id: el.value, name: el.label} }))
              setShowError(false)
            }}
            onInputChange={event => {
              setQuery(event)
            }}
          />
        </div>
        <button
        className="bg-gradient-to-r from-blue-700 to-blue-900 hover:from-blue-800 hover:to-blue-950 hover:cursor-pointer text-white font-semibold rounded-xl px-8 py-3 transition-all duration-150 shadow-md mt-3 md:mt-0 sticky-btn max-md:w-full max-md:text-3xl"
          type="button"
          onClick={() => {
            if (result.length === 0) {
              setShowError(true)
              return
            }
            onSelect(result)
          }}
        >
          {selectButtonText}
        </button>
      </div>
      {showError && (
        <div className="mt-2 w-full flex justify-center">
          <span className="text-red-800 text-lg font-semibold bg-gray-100 rounded-xl px-4 py-2 shadow">Musisz wybrać co najmniej 1 region!</span>
        </div>
      )}
    </>
  )
}

export default SearchElementMulti
